import {useEffect, useState} from "react";
import {motion} from "framer-motion";
import {IMonthlyInvoice} from "../../../utils/interfaces/MonthlyInvoice/IMonthlyInvoice";
import MonthlyInvoiceRow from "./MonthlyInvoiceRow";
import {IoMdAdd} from "react-icons/io";
import {useAccounting} from "../../../utils/contexts/accounting_context";
import {IoClose} from "react-icons/io5";
import {IYear} from "../../../utils/interfaces/IYear";
import useApiGetMonthlyInvoicesDetails from "./api-hooks/useApiGetMonthlyInvoicesDetails";


function MonthlyInvoicesList() {
    const {
        selectedInvoice,
        isMonthlyInvoiceFormOpen,
        selectIsMonthlyInvoiceFormOpen,
        selectIsMonthlyInvoiceOverlayOpen,
        selectMonthlyInvoice,
        selectedYear,
        selectedPeriod,
    } = useAccounting();


    const {
        data,
        isLoading,
        isError,
        error
    } = useApiGetMonthlyInvoicesDetails(selectedPeriod?.month, selectedYear?.year, selectedInvoice?.restaurateur.id);


    const mapped_objs = data && data.map((obj: IMonthlyInvoice, index) => (
        <motion.div
            key={obj.id}
            initial={{x: '150%'}}
            animate={{x: '0%'}}
            transition={{duration: 0.2, delay: index * 0.03}}
            className='mb-5'
        >
            <MonthlyInvoiceRow obj={obj}/>
        </motion.div>

    ));

    const handleToggleMonthlyInvoiceFormOpen = () => {
        selectMonthlyInvoice(undefined);
        if (isMonthlyInvoiceFormOpen) {
            selectIsMonthlyInvoiceFormOpen(false);
        }
        if (!isMonthlyInvoiceFormOpen) {
            selectIsMonthlyInvoiceFormOpen(true);
        }
    }


    let labelStyle = "text-sm text-gray-500 font-bold mr-1";
    let contentStyle = "text-sm text-gray-800 font-bold mr-1";


    return (
        <>


            {selectedInvoice?.restaurateur &&
                <div className='gap-2 pb-4' style={{display: 'flex', justifyContent: 'space-between'}}>

                    <button
                        onClick={() => handleToggleMonthlyInvoiceFormOpen()}
                        className="p-2 rounded-full bg-mcia_salmon text-white hover:bg-mcia_orange cursor-pointer"
                    >
                        <div className="flex items-center justify-center">
                            <IoMdAdd title='ADD INVOICE'/>
                        </div>
                    </button>
                    <button
                        onClick={() => selectIsMonthlyInvoiceOverlayOpen(false)}
                        className="p-2 rounded-full bg-mcia_salmon text-white hover:bg-mcia_orange cursor-pointer"
                    >
                        <div className="flex items-center justify-center">
                            <IoClose title='CLOSE'/>
                        </div>
                    </button>
                </div>
            }

            <div className='mb-4'>
                <div className="flex flex-grow">
                    <label className={labelStyle}>Year: </label>
                    <label className={contentStyle}>{selectedYear?.year}</label>
                </div>
                <div className="flex flex-grow">
                    <label className={labelStyle}>Period: </label>
                    <label className={contentStyle}>{selectedPeriod?.month_name}</label>
                </div>
                <div className="flex flex-grow">
                    <label className={labelStyle}>Ristoratore: </label>
                    <label className={contentStyle}>{selectedInvoice?.restaurateur.name}</label>
                </div>
                <div className="flex flex-grow">
                    <label className={labelStyle}>Vat: </label>
                    <label className={contentStyle}>{selectedInvoice?.restaurateur.vat_number}</label>
                </div>
                <div className="flex flex-grow">
                    <label className={labelStyle}>Email: </label>
                    <label className={contentStyle}>{selectedInvoice?.restaurateur.email}</label>
                </div>
            </div>

            <div className="flex flex-col ml-5">
                {mapped_objs}
            </div>

        </>


    );
}

export default MonthlyInvoicesList;